export default "__VITE_ASSET__gk8T1u1J__"